import axios from 'axios';
import { API_VIRSION } from 'config';
// Suggest Hashtag api

export const getHashtags = (params) => axios.get(`${API_VIRSION}/admin/hashtag`, { params });

export const approveHashtag = (id) => axios.put(`${API_VIRSION}/admin/hashtag/${id}/approve`);

export const rejectHashtag = (id) => axios.put(`${API_VIRSION}/admin/hashtag/${id}/reject`);
